import { render, staticRenderFns } from "./TermReports.vue?vue&type=template&id=40a32d26&scoped=true"
import script from "./TermReports.vue?vue&type=script&lang=js"
export * from "./TermReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a32d26",
  null
  
)

export default component.exports